import React, { HTMLAttributes, PropsWithChildren } from 'react'

export const FullContent = ({
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className="flex flex-col min-h-screen" {...rest}>
      <div className="w-full self-center">{children}</div>
    </div>
  )
}
